import React from 'react';
import './styles/app-header.scss';
import { useTranslation } from 'react-i18next';

const AppHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="app-header">
      <div className="app-header-box">
        <div>
          <svg
            width="66"
            height="32"
            viewBox="0 0 66 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>{t('app.title')}</title>
            <g clipPath="url(#clip0_262_3943)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.782569 31.9674L66 25.238L65.2134 17.8892L-0.00404358 24.6186L0.782569 31.9674Z"
                fill="#FFE900"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.6051 15.5992C29.2971 15.5992 27.4241 13.7601 27.4241 11.4941C27.4241 9.22808 29.2971 7.38902 31.6051 7.38902C33.9131 7.38902 35.7863 9.22808 35.7863 11.4941C35.7863 13.7601 33.9131 15.5992 31.6051 15.5992ZM31.6051 4.10498C27.4575 4.10498 24.0792 7.38902 24.0792 11.4941C24.0792 15.5663 27.4575 18.8832 31.6051 18.8832C35.7863 18.8832 39.1311 15.5663 39.1311 11.4941C39.1311 7.38902 35.7863 4.10498 31.6051 4.10498ZM55.8248 15.5992C53.5168 15.5992 51.6437 13.7601 51.6437 11.4941C51.6437 9.22808 53.5168 7.38902 55.8248 7.38902C58.1328 7.38902 60.0059 9.22808 60.0059 11.4941C60.0059 13.7601 58.1328 15.5992 55.8248 15.5992ZM55.8248 4.10498C51.6772 4.10498 48.2988 7.38902 48.2988 11.4941C48.2988 15.5663 51.6772 18.8832 55.8248 18.8832C60.0059 18.8832 63.3507 15.5663 63.3507 11.4941C63.3507 7.38902 60.0059 4.10498 55.8248 4.10498Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M51.2416 3.67775V0.394287H36.1895V3.67775H42.042V18.4886H45.3878V3.67775H51.2416Z"
                fill="black"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2683 7.78317V11.0673H15.8908C14.824 13.8192 12.7895 15.5993 10.4321 15.5993C8.72619 15.5993 7.15404 14.9096 6.0168 13.7931C4.87955 12.6764 4.17713 11.1329 4.17713 9.42523C4.17713 7.71752 4.87955 6.20688 6.0168 5.09025C7.15404 3.97369 8.72619 3.28404 10.4321 3.28404C12.1714 3.28404 13.7435 3.97369 14.8807 5.09025L17.2556 2.75862C15.5163 1.05092 13.1079 0 10.4321 0C7.7896 0 5.38124 1.05092 3.6419 2.75862C1.90257 4.46633 0.832245 6.83082 0.832245 9.42523C0.832245 12.0525 1.90257 14.3841 3.6419 16.0919C5.38124 17.7995 7.7896 18.8833 10.4321 18.8833C13.7075 18.8833 16.6534 16.8126 18.3929 13.5246C18.3929 15.0542 18.3929 16.672 18.3929 18.4893H21.7377V7.78317C21.7377 7.78317 13.2506 7.78317 11.2683 7.78317Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="clip0_262_3943">
                <rect width="66" height="31.9688" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
